/* eslint-disable */
import { normalizeStr } from "utils/general/strings";

/**
 * Sorts an array of elements based on a specific attribute.
 * @param {Array} elements The data array to be sorted.
 * @param {string} attribute The attribute of the elements to sort by.
 */
export const SortElementSelect = (elements, attribute) => {
    elements.sort(function (a, b) {
        if (a[attribute] === null) a[attribute] = "";
        if (b[attribute] === null) b[attribute] = "";

        if (normalizeStr(a[attribute]) > normalizeStr(b[attribute])) {
            return 1;
        }
        if (normalizeStr(a[attribute]) < normalizeStr(b[attribute])) {
            return -1;
        }
        // a must be equal to b
        return 0;
    });
}